import { __decorate } from "tslib";
import { AsnProp, OctetString } from "@peculiar/asn1-schema";
import { AlgorithmIdentifier } from "@peculiar/asn1-x509";
export class HashAlgAndValue {
    constructor(params = {}) {
        this.hashAlg = new AlgorithmIdentifier();
        this.hashValue = new OctetString();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AlgorithmIdentifier })
], HashAlgAndValue.prototype, "hashAlg", void 0);
__decorate([
    AsnProp({ type: OctetString })
], HashAlgAndValue.prototype, "hashValue", void 0);
